import { render, staticRenderFns } from "./dzck.vue?vue&type=template&id=6ad1bb4c"
import script from "./dzck.vue?vue&type=script&lang=js"
export * from "./dzck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports